import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatInputModule} from '@angular/material/input';
import {FeedbackDialogComponent} from './feedback-dialog.component';

@NgModule({
  imports: FeedbackDialogModule.IMPORTS,
  declarations: FeedbackDialogModule.DECLARATIONS,
  exports: FeedbackDialogModule.DECLARATIONS
})
export class FeedbackDialogModule {
  public static readonly IMPORTS: any[] = [CommonModule, MatDialogModule, MatButtonModule, MatInputModule, FormsModule];

  public static readonly DECLARATIONS: any[] = [FeedbackDialogComponent];
}
